import columns from '../../react-table/helpers/columns';
import TableDefinitions from '../../../common/TableDefinitions';

export const ediTypeFormatting = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row.dailyRouteLeadingCountStatus.includes('EDI')) {
      className = 'bg-green';
    }
  }
  return {
    className,
  };
};

export const rfidTypeFormatting = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row.dailyRouteLeadingCountStatus.includes('RFID')) {
      className = 'bg-green';
    }
  }
  return {
    className,
  };
};

export function callUseEdi(rowInfo) {
  return rowInfo && rowInfo.row.dailyRouteLeadingCountStatus.includes('MAX') ? {
      path: '/daily-route-leading-count-status',
      tableId: TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id,
      text: 'Use EDI',
    } : {
    path: '/daily-route-leading-count-status',
    tableId: TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id,
    text: 'Use Max',
  };
}

export default (data) => {
  const {
    FilteredDateColumn,
    FilteredNumberColumn,
    FilteredPercentageColumn,
    FilteredTextColumn,
    NavigationColumn,
    EditButtonColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredNumberColumn('Id', 'assetRouteId').withShow(false).withWidth(127.283),
        new FilteredDateColumn('Date', 'date').withWidth(127.3),
        new FilteredTextColumn('Outbound Operator', 'outboundOperator').withWidth(127.283),
        new FilteredTextColumn('Outbound IMPC', 'outboundImpc').withWidth(127.283),
        new FilteredTextColumn('Inbound Operator', 'inboundOperator').withWidth(127.3),
        new FilteredTextColumn('Inbound IMPC', 'inboundImpc').withWidth(127.283),
        new FilteredNumberColumn('Generated From PREDES', 'generatedFromPredes').withWidth(127.283),
        new FilteredNumberColumn('Manual PRE-ADVISE', 'manualPreAdvice').withWidth(127.283),
        new FilteredNumberColumn('Central Repat', 'centralRepatriation').withWidth(127.283),
        new FilteredNumberColumn('Total', 'total').withGetProps(ediTypeFormatting).withWidth(127.283),
        new FilteredNumberColumn('RFID Base Sleeve', 'rfidBaseSleeve').withGetProps(rfidTypeFormatting).withWidth(127.283),
        new FilteredNumberColumn('RFID - EDI', 'rfidEdi').withWidth(127.283),
        new FilteredPercentageColumn('(RFID - EDI)/EDI %', 'rfidEdiRate').withWidth(127.283),
        new FilteredTextColumn('Leading Count Status', 'dailyRouteLeadingCountStatus').withWidth(127.283),
        new NavigationColumn(new EditButtonColumn('', 'dailyRouteLeadingCountStatus').withWidth(127.283), callUseEdi),
      ],
    },
  ];
};
